<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
      </div>
      <div class="modal-body">
        <textarea
          *ngIf="!readOnly"
          class="form-control"
          rows="6"
          [(ngModel)]="draft"
          placeholder="Enter notes here..."
        ></textarea>
        <p *ngIf="readOnly" style="white-space: pre-wrap; margin: 0;">{{ notes || 'No notes recorded.' }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        <button *ngIf="!readOnly" type="button" class="btn btn-primary" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>
